// Vendor
import * as bootstrap from 'bootstrap';
import * as LazyLoad from 'vanilla-lazyload';
import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js"
import Swiper from "swiper/bundle";
import SmoothScroll from "smooth-scroll";

// Make available globally
window.bootstrap = bootstrap;
window.LazyLoad = LazyLoad;
window.Fancybox = Fancybox;
window.Swiper = Swiper;
window.SmoothScroll = SmoothScroll;

// Global Bootstrap Prevent FocusTrap
$.fn.modal.Constructor.prototype._initializeFocusTrap = function () { return { activate: function () { }, deactivate: function () { } } };
